// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__AWKY9","spin":"loader_spin__aMBSc","loader__wrapper":"loader_loader__wrapper__ouACL"};